import { get, post } from '../axios'
import { formRequest } from 'cupshe-axios'

// 分页查询物料列表
export function appTab_material_page_post(map, option) {
  return post(
    `${process.env.VUE_APP_SETTING}/appTab/material/page`,
    map,
    option
  ).then(response => response)
}

// 新建物料
export function appTab_material_create_post(map, option) {
  return post(
    `${process.env.VUE_APP_SETTING}/appTab/material/create`,
    map,
    option
  ).then(response => response)
}

// 启用/停用物料
export function appTab_material_changeStatus_post(map, option) {
  return post(
    `${process.env.VUE_APP_SETTING}/appTab/material/changeStatus`,
    map,
    option
  ).then(response => response)
}

// 查询全部 APP Tab 路由
export function appTab_material_routes_get(option) {
  return get(
    `${process.env.VUE_APP_SETTING}/appTab/material/routes`,
    {},
    option
  ).then(response => response)
}

// 删除物料
export function appTab_material_delete_post(map, option) {
  return post(
    `${process.env.VUE_APP_SETTING}/appTab/material/delete`,
    map,
    option
  ).then(response => response)
}

// 编辑物料
export function appTab_material_update_post(map, option) {
  return post(
    `${process.env.VUE_APP_SETTING}/appTab/material/update`,
    map,
    option
  ).then(response => response)
}

// 上传物料图片
export function appTab_material_image_upload_post(file, materialType, option) {
  return formRequest(
    `${
      process.env.VUE_APP_SETTING
    }/appTab/material/image/upload?materialType=${encodeURIComponent(
      materialType
    )}`,
    { file },
    option
  ).then(response => response)
}

// 查询当前站点可装配物料
export function appTab_material_enabledCandidates_post(map, option) {
  return post(
    `${process.env.VUE_APP_SETTING}/appTab/material/enabledCandidates`,
    map,
    option
  ).then(response => response)
}

// 查询站点最新已发布配置
export function appTab_config_publishedDetail_get(map, option) {
  return get(
    `${process.env.VUE_APP_SETTING}/appTab/config/publishedDetail`,
    map,
    option
  ).then(response => response)
}

// 发布 APP Tab 配置
export function appTab_config_publish_post(map, option) {
  return post(
    `${process.env.VUE_APP_SETTING}/appTab/config/publish`,
    map,
    option
  ).then(response => response)
}

// 分页查询 APP Tab 版本记录
export function appTab_version_page_post(map, option) {
  return post(
    `${process.env.VUE_APP_SETTING}/appTab/version/page`,
    map,
    option
  ).then(response => response)
}

// 发布站点完整 AB 实验配置
export function appTab_experiment_config_publish_post(map, option) {
  return post(
    `${process.env.VUE_APP_SETTING}/appTab/experiment/config/publish`,
    map,
    option
  ).then(response => response)
}

// 分页查询 APP Tab 实验记录
export function appTab_experiment_version_page_post(map, option) {
  return post(
    `${process.env.VUE_APP_SETTING}/appTab/experiment/version/page`,
    map,
    option
  ).then(response => response)
}

// 查询全部站点最新已发布配置
export function appTab_config_allPublished_get(option) {
  return get(
    `${process.env.VUE_APP_SETTING}/appTab/config/allPublished`,
    {},
    option
  ).then(response => response)
}

// 导出全部站点最新已发布配置
export function appTab_config_exportAllPublished_get(option) {
  return get(
    `${process.env.VUE_APP_SETTING}/appTab/config/exportAllPublished`,
    {},
    { ...option, responseType: 'blob' }
  ).then(response => response)
}
